import type { Action } from 'redux';
import { combineEpics } from 'redux-observable';
import type { Epic } from '@helpcenter/epics-rxjs';
import { Observable } from '@helpcenter/epics-rxjs';
import fetchModel from 'epics/model/fetcher';
import type { UpdateXsrfAction } from 'state/actions/env';
import { updateXsrfAction } from 'state/actions/env';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { FETCH_HELP_CENTER_BRANDING_MODEL } from '../model/help-center/actions';

// This epic listens to ALL model actions. All model actions starts with epic.model so we listen to those.
export const updateXsrfEpic: Epic<Action, UpdateXsrfAction> = (action$: Observable<Action>) => {
    return (
        action$
            // Suppressing existing violation. Please fix this.
            .filter((action: Action) =>
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                FeatureGates.checkGate('jsm_portal_login_removal_xsrf_model_call')
                    ? // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                      action.type.startsWith('epic.model') && action.type !== FETCH_HELP_CENTER_BRANDING_MODEL
                    : // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                      action.type.startsWith('epic.model')
            )
            .switchMap(() => fetchModel({ type: 'xsrfToken', params: {} }))
            // jsd-customer-portal-models-without-backbone
            // When cleaning up remove all instances of "env" here. Just use xsrfToken directly.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
            .filter((response) => !!response && (!!response.xsrfToken || !!(response as any).env.xsrfToken))
            // jsd-customer-portal-models-without-backbone
            // When cleaning up remove all instances of "env" here. Just use xsrfToken directly.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
            .map((response) => updateXsrfAction(response.xsrfToken || (response as any).env.xsrfToken))
            .catch((_) => Observable.never() as Observable<UpdateXsrfAction>)
    );
};

export default combineEpics(updateXsrfEpic);
